module.exports = __webpack_public_path__ + "2793ab4d47d65df2f1370dcee4766211.svg";